import React, {useRef} from 'react';
import Header from '../Header';
import Footer from './Footer';
import useSearchParams from '../../../useSearchParams';

const ProspectScoreFilter = () => {
  const {query, setQuery} = useSearchParams();
  const refFrom = useRef(null);
  const refTo = useRef(null);

  const scoreRanks = [
    {value: 'a', label: 'A'},
    {value: 'b', label: 'B'},
    {value: 'c', label: 'C'},
    {value: 'd', label: 'D'},
  ];

  const handleRankCheckboxChange = (value: string, checked: boolean) => {
    const currentRanks = query?.totalScoreRanks || [];
    let newRanks;

    if (checked) {
      newRanks = [...currentRanks, value];
    } else {
      newRanks = currentRanks.filter((rank: string) => rank !== value);
    }

    setQuery({
      ...query,
      totalScoreRanks: newRanks,
    });
  };

  return (
    <>
      <Header title="顧客スコア" />
      <div className="p-6 bg-background flex-1 flex flex-col gap-4 rounded-b overflow-y-scroll">
        <div className="bg-white p-6 rounded flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label className="text-foreground font-bold">
              顧客スコア（ランク）
            </label>
            <div className="flex flex-col gap-2">
              {scoreRanks.map((rank) => (
                <label
                  key={rank.value}
                  className="flex items-center gap-2 cursor-pointer"
                  htmlFor={`rank-checkbox-${rank.value}`}
                >
                  <input
                    id={`rank-checkbox-${rank.value}`}
                    type="checkbox"
                    checked={
                      query?.totalScoreRanks?.includes(rank.value) || false
                    }
                    onChange={(e) =>
                      handleRankCheckboxChange(rank.value, e.target.checked)
                    }
                    className="form-checkbox"
                  />
                  <span className="text-foreground">{rank.label}</span>
                </label>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-foreground font-bold">顧客スコア</label>
            <div className="flex items-center">
              <input
                min={1}
                type="number"
                defaultValue={query?.prospectScore?.from}
                onBlur={(e) => {
                  const inputValue = e.target.value;
                  if (inputValue === '') {
                    const {from, ...restProspectScore} =
                      query?.prospectScore || {};
                    setQuery({
                      ...query,
                      prospectScore: {...restProspectScore},
                    });
                  } else if (!isNaN(Number(inputValue))) {
                    setQuery({
                      ...query,
                      prospectScore: {
                        ...(query?.prospectScore || {}),
                        from: Number(inputValue),
                      },
                    });
                  }
                }}
                ref={refFrom}
                className="form-input w-24 p-2"
              />
              <span className="mx-2">~</span>
              <input
                min={1}
                type="number"
                defaultValue={query?.prospectScore?.to}
                onBlur={(e) => {
                  const inputValue = e.target.value;
                  if (inputValue === '') {
                    const {to, ...restProspectScore} =
                      query?.prospectScore || {};
                    setQuery({
                      ...query,
                      prospectScore: {
                        ...restProspectScore,
                      },
                    });
                  } else if (!isNaN(Number(inputValue))) {
                    setQuery({
                      ...query,
                      prospectScore: {
                        ...(query?.prospectScore || {}),
                        to: Number(inputValue),
                      },
                    });
                  }
                }}
                ref={refTo}
                className="form-input w-24 p-2"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer
        onClear={() => {
          setQuery({...query, prospectScore: {}, totalScoreRanks: []});
          if (refFrom.current) refFrom.current.value = '';
          if (refTo.current) refTo.current.value = '';
        }}
      />
    </>
  );
};

export default ProspectScoreFilter;
